export default __webpack_public_path__ + "static/media/scrolltop.0b7eb20f.svg";